import { observable, computed } from 'mobx'
import Model from '../shared/model'

import validate from '../shared/decorators/model/validate'

@validate({

  origId: 'required|number|min:1',
  type: 'required|regexp:(museum)|(program)|(guided-tour)',
  isToBeDeleted: 'required|bool',
  isDeactivated: 'required|bool',
  isNew: 'required|bool',

})
export default class Release extends Model {

  @observable dirtyStatus = 0

  @observable isDeactivated = 0

  @observable isNew = 0

  @observable isToBeDeleted = null

  @observable museumName = ''

  @observable origId = null

  @observable title = ''

  @observable type = ''

  @observable updatedAt = ''

  @observable dirty = true

  constructor(...args) {
    super(...args)

    this.initValidate()
  }

  parse(data) {

    return data
  }

  @computed get asJSON() {

    return {
      id: this.id,
      dirtyStatus: this.dirtyStatus,
      isDeactivated: this.isDeactivated,
      isNew: this.isNew,
      isToBeDeleted: this.isToBeDeleted,
      museumName: this.museumName,
      origId: this.origId,
      title: this.title,
      type: this.type,
      updatedAt: this.updatedAt,
    }

  }

  getJSON() {
    return this.asJSON
  }

}



// WEBPACK FOOTER //
// ./src/release/model.js